<div *ngIf="showNoSubscriptionOverlay" class="no-subscription-overlay">
  <div class="card">
    <div class="flex flex-col justify-center items-center gap-8 p-2 text-center">
      <span class="text-2xl font-bold">
        {{ overlayMessage | translate }}
      </span>

      <p-button
        label="{{ 'subscriptionAlert.fixIt' | translate }}"
        [routerLink]="['/app', 'settings', 'company-subscription']"
        size="large"
      />
    </div>
  </div>
</div>
